import {
  Grid,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableBody,
} from "@mui/material";
import React from "react";
import {
  BaseGrid,
  StyledTableRow,
  TableCellHeader,
  TableCellWidth,
  TitleTypography,
} from "../KandidatViewPage";
import { RiwayatPekerjaanResponse } from "../../../models/RiwayatPekerjaan";

type Props = { data: RiwayatPekerjaanResponse[] };

export default function DataPekerjaanKandidatPage({ data }: Props) {
  return (
    <BaseGrid container item xs={12} justifyContent="center">
      <Grid
        container
        item
        xs={12}
        sx={{
          backgroundColor: "#00ACED",
          color: "#fff",
          marginBottom: "4%",
        }}
      >
        <TitleTypography>Data Riwayat Pekerjaan</TitleTypography>
      </Grid>
      <Grid container item xs={12}>
        <TableContainer component={Paper}>
          <Table size="small" aria-label="a dense table">
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: "rgba(0,0,0,0.1)",
                }}
              >
                <TableCellHeader>Perusahaan</TableCellHeader>
                <TableCellHeader>Usaha</TableCellHeader>
                <TableCellHeader>Masuk</TableCellHeader>
                <TableCellHeader>Keluar</TableCellHeader>
                <TableCellHeader>Karyawan</TableCellHeader>
                <TableCellHeader>Atasan Langsung</TableCellHeader>
                <TableCellHeader>Direktur</TableCellHeader>
                <TableCellHeader>Gaji</TableCellHeader>
                <TableCellHeader>Alasan Berhenti</TableCellHeader>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, key) => (
                <StyledTableRow
                  key={key}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCellWidth>{row.NAMA_PERUSAHAAN}</TableCellWidth>
                  <TableCellWidth>{row.JENIS_USAHA}</TableCellWidth>
                  <TableCellWidth>
                    {row.JABATAN_AWAL} , {row.TAHUN_MASUK}
                  </TableCellWidth>
                  <TableCellWidth>
                    {row.JABATAN_AKHIR} , {row.TAHUN_KELUAR}
                  </TableCellWidth>
                  <TableCellWidth>{row.JUMLAH_KARYAWAN}</TableCellWidth>
                  <TableCellWidth>{row.NAMA_ATASAN_LANGSUNG}</TableCellWidth>
                  <TableCellWidth>{row.NAMA_DIREKTUR}</TableCellWidth>
                  <TableCellWidth>
                    {row.GAJI_TERAKHIR ? row.GAJI_TERAKHIR : "-"}
                  </TableCellWidth>
                  <TableCellWidth>{row.ALASAN_BERHENTI}</TableCellWidth>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </BaseGrid>
  );
}
